import React from 'react'
import "./HeroimgStyles.css"
import IntroImg from "../assets/computerimage.jpg"
import { Link } from 'react-router-dom'
import { FaGithub,FaLinkedin} from "react-icons/fa"
export const Heroimg = () => {
  return (
    <div className='hero'>
      
        <div className='mask'>
            <img className='into-img'
             src={IntroImg} alt="IntoImg"/>
        </div>
        <div className='content'>
            <h1>Hi, I am a Full Stack Web Developer</h1>
            <div className="social-stats">
            <a href="https://github.com/rajeshdeo" target={"_blank"} rel="noopener noreferrer"><FaGithub size={50} 
                            style={{color:"blue", marginRight:"1rem"}}/></a>
                            
            <a href="https://www.linkedin.com/in/rajesh-kumar-801161258/" target={"_blank"} rel="noopener noreferrer"><FaLinkedin size={50} 
                            style={{color:"blue", marginRight:"1rem"}}/></a>
            </div>
            <div>
                <Link to="/project" className='btn'>Projects</Link>
                <Link to="/contact" className='btn btn-light'>CONTACT</Link>
            </div>
        </div>
    </div>
  )
}
